import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

export const getUserGroups = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/settings/getusergroups`;
    return await axios.get(url);
}

export const getAppSettings = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/settings/getappsettings`;
    return await axios.get(url);
}

export const getAppSettingsTipoCategoria = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/settings/getappsettingstipocategoria`;
    return await axios.get(url);
}

export const setAppSettings = async (applicationSettingsData: any): Promise<any> => {
    let url = baseAxiosUrl + `/api/settings/setappsettings`;
    return await axios.post(url, applicationSettingsData);
}

export const searchGroups = async (query: string): Promise<any> => {
    let url = baseAxiosUrl + "/api/settings/search/" + query;
    return await axios.get(url);
}

export const getGroups = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/settings/getgroupdata`;
    return await axios.get(url);
}

export const getLanguage = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/settings/getlanguage`;
    return await axios.get(url);
}

export const getVersion = async (): Promise<any> => {
    let url = baseAxiosUrl + `/version`;
    return await axios.get(url);
}

export const getAppCatalogId = async (appManifestId: string): Promise<any> => {
    let url = baseAxiosUrl + `/api/settings/getappcatalogid?appManifestId=${appManifestId}`;
    return await axios.get(url);
}

export const getAdmins = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/settings/getadmins`;
    return await axios.get(url);
}

export const getSettingsServiceTime = async (): Promise<any> => {
    let url = baseAxiosUrl + `/api/settings/getsettingsservicetime`;
    return await axios.get(url);
}

